
import { defineComponent, PropType } from "vue";
import { WorksData } from "modules/construction-work/src/Common/interface";

export default defineComponent({
    name: 'Tabs',
    props: {
        works: {
            type: Object as PropType<WorksData>,
            required: true,
        },
        isShowCW: {
            type: Boolean,
            default: true,
        },
        isShowIncident: {
            type: Boolean,
            default: false,
        },
        workTotalCount: {
            type: Number,
            default: 0,
        },
        incidentTotalCount: {
            type: Number,
            default: 0,
        }
    },
    emits: ['change-tab'],
});
